import { render, staticRenderFns } from "./PendingAudit.vue?vue&type=template&id=528c7f9b"
import script from "./PendingAudit.vue?vue&type=script&lang=js"
export * from "./PendingAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports